import { useState } from "react";
import { apiFetch } from "../utils/api";

export default function CreateUserForm({ user, onUserCreated }) {
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("admin");
  const [tempPassword, setTempPassword] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setTempPassword(null);
    setLoading(true);

    try {
      const res = await apiFetch("/admin/users", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${user.token}`
        },
        body: JSON.stringify({ username, role })
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || "Failed to create user");
        setLoading(false);
        return;
      }

      setTempPassword(data.tempPassword);
      setUsername("");
      setRole("admin");
      onUserCreated();
    } catch {
      setError("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-user-container">
      <h3>Create New User</h3>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />

        <select value={role} onChange={(e) => setRole(e.target.value)}>
          <option value="admin">Admin</option>
          <option value="superadmin">Superadmin</option>
        </select>

        <button type="submit" disabled={loading}>
          {loading ? "Creating..." : "Create User"}
        </button>
      </form>

      {tempPassword && (
        <div className="temp-password-box">
          <p><strong>Temporary Password</strong></p>
          <code>{tempPassword}</code>
          <p className="warning">
            Copy this now — it will not be shown again.
          </p>
        </div>
      )}

      {error && <p className="error-text">{error}</p>}
    </div>
  );
}
